import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import styles from "./index.module.scss";
import { Button, PageHeader, Popconfirm, Space, Table, Popover, Switch, Checkbox, Input } from "antd";
import type { ColumnsType } from "antd/lib/table";
import UserBindRoleDialog from "./dialogs/UserBindRoleDialog";
import UserBindAccountDialog from "./dialogs/UserBindAccountDialog";
// import RoleStore, { RoleInfo } from "../../stores/RoleStore";
import UserStore, { UserInfo } from "../../../stores/Admin/UserStore";
import UserSyncButton from "./UserSyncButton";
import AddUserButton from "./AddUserButton";
import SearchBox from "./SearchBox";
const RolesPage: React.FC = (props) => {
  const { users, pagination } = UserStore;
  const [visibles, setVisibles] = useState<{ [key: string]: any }>({
    roleAdd: false,
    roleEdit: false,
    bindRole: false,
    bindAccount: false,
  });
  const updateVisibles = (key: string, value: any, account: string = "") => {
    visibles[key] = value;
    setVisibles({ ...visibles });
    setAccount(account);
  };
  // const [id, setId] = useState<number>(0);
  const [account, setAccount] = useState<string>("");
  const [keyword, setKeyword] = useState<string>();

  useEffect(() => {
    UserStore.getUserList();
    UserStore.getRoleList();
    return () => {
      UserStore.setPagination({ total: 0, pageNum: 1, pageSize: 10 });
    };
  }, []);

  useEffect(() => {
    UserStore.setPagination({ ...pagination, pageNum: 1 });
    UserStore.getUserList(1, pagination.pageSize, keyword);
  }, [keyword]);

  const paginationProps = {
    showSizeChanger: false,
    showQuickJumper: false,
    total: pagination.total, // 数据总数
    pageSize: pagination.pageSize, // 每页条数
    current: pagination.pageNum, // 当前页码
    onChange: (pageNum: number, pageSize: number) => {
      UserStore.setPagination({ ...pagination, pageNum, pageSize });
      UserStore.getUserList(pageNum, pageSize, keyword);
    },
    showTotal: (total: number) => {
      return `共 ${total} 条`;
    },
  };

  const columns: ColumnsType<UserInfo> = [
    {
      title: "序号",
      dataIndex: "num",
      key: "num",
      render: (text, record, index) => (
        <span>{(paginationProps.current - 1) * paginationProps.pageSize + Number(index) + 1}</span>
      ),
    },
    {
      title: "用户名称",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "账号",
      dataIndex: "account",
      key: "account",
    },
    {
      title: "联系方式",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "分组",
      dataIndex: "roleName",
      key: "roleName",
      render: (text) =>
        text && text.split(",").length > 1 ? (
          <Popover
            content={text && text.split(",").map((item: string) => <div key={item}>{item}</div>)}
            title="所属分组"
          >
            <a>{text && text.split(",")[0]}...</a>
          </Popover>
        ) : (
          <a>{text && text.split(",")[0]}</a>
        ),
    },
    {
      title: "操作",
      key: "action",
      width: 280,
      render: (_, record) => {
        return (
          <Space size="middle">
            <a
              onClick={() => {
                updateVisibles("bindRole", true, record.account);
              }}
            >
              分组管理
            </a>

            <Popconfirm
              title="是否删除该项目"
              okText="确认"
              cancelText="取消"
              onConfirm={() => {
                UserStore.removeUser(record.id);
              }}
            >
              <a>删除</a>
            </Popconfirm>
            {/* <a
              onClick={() => {
                UserStore.getAccountList(record.phone);
                updateVisibles("bindAccount", true, record.phone);
                setName(record.name);
              }}
            >
              绑定子账户
            </a> */}
            <Switch
              checkedChildren="启用"
              unCheckedChildren="禁用"
              defaultChecked={record.status === 1}
              onChange={(checked: boolean) => (checked ? UserStore.openUser(record.id) : UserStore.offUser(record.id))}
            />
            {/*
            {record.status === 1 ? (
              <Popconfirm
                title="确定禁用该用户吗?"
                onConfirm={() => UserStore.offUser(record.id)}
                // onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <a href="#">禁用</a>
              </Popconfirm>
            ) : (
              <Popconfirm
                title="确定启用该用户吗?"
                onConfirm={() => UserStore.openUser(record.id)}
                // onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <a href="#">启用</a>
              </Popconfirm>
            )} */}
          </Space>
        );
      },
    },
    {
      title: "管理员权限",
      key: "orAdmin",
      align: "center",
      render: (_, record) => {
        return (
          <Checkbox
            checked={!!record.orAdmin}
            onChange={() => {
              if (record.orAdmin) {
                UserStore.offAdmin(record.id);
              } else {
                UserStore.openAdmin(record.id);
              }
            }}
          />
        );
      },
    },
  ];

  return (
    <>
      <PageHeader
        title="用户管理"
        extra={[<SearchBox onSearch={setKeyword} />, <UserSyncButton />, <AddUserButton />]}
      />

      <div className={styles.content}>
        {/* <div style={{ marginBottom: 16 }}>
          <Button
            type="primary"
            onClick={() => {
              updateVisibles("roleAdd", true);
            }}
          >
            新建用户
          </Button>
        </div> */}
        <div className={styles.table_content}>
          <Table columns={columns} dataSource={users} pagination={paginationProps} />
        </div>
      </div>
      <UserBindRoleDialog
        visible={visibles.bindRole}
        account={account}
        close={() => updateVisibles("bindRole", false)}
      />
      {/* <UserBindAccountDialog
        visible={visibles.bindAccount}
        phone={account}
        name={name}
        close={() => updateVisibles("bindAccount", false)}
      /> */}
    </>
  );
};

export default observer(RolesPage);
